export default "/static/flex_2_tiny.png";